import { useNavigate } from "react-router-dom";
import { Undo2 } from "lucide-react";
import { Button } from "./ui/button";
import { StatusBadge } from "./StatusBadge";
import { useAuth } from "../context/AuthContext";
import { hasRole } from "../lib/roles";

export const InspectionResult = ({ result, backTo }) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (result.offline) {
    return (
      <div className="max-w-lg mx-auto px-4 py-16 text-center space-y-5">
        <h1 className="text-2xl font-black uppercase text-slate-100">Enregistré hors ligne</h1>
        <p className="text-slate-400 text-sm" data-testid="inspection-offline-message">
          Vous êtes hors connexion. Cette visite sera automatiquement synchronisée avec la base au retour du réseau.
        </p>
        <Button data-testid="inspection-done-back-button" onClick={() => navigate(backTo)} className="bg-cyan-500 hover:bg-cyan-400 text-black font-bold uppercase">
          Retour
        </Button>
      </div>
    );
  }

  const showReactivate = result.Statut_Front_Apres_Validation === "SUSPENDUE" && result.Front_ID && hasRole(user, "RESPONSABLE", "ADMINISTRATEUR");

  return (
    <div className="max-w-lg mx-auto px-4 py-16 text-center space-y-5">
      <h1 className="text-2xl font-black uppercase text-slate-100">Enregistré avec succès</h1>
      <div className="text-5xl font-black text-cyan-400">{result.Score}%</div>
      <p className="text-slate-400 text-sm">Statut du front après validation :</p>
      <StatusBadge status={result.Statut_Front_Apres_Validation} />
      {result.Statut_Front_Apres_Validation === "SUSPENDUE" && result.Statut_Front_Avant_Inspection !== "SUSPENDUE" && (
        <p className="text-red-300 text-sm bg-red-950/40 border border-red-900 rounded-lg px-4 py-3">
          Une anomalie critique a été détectée : le front vient d'être automatiquement suspendu.
        </p>
      )}
      {result.Statut_Front_Avant_Inspection === "SUSPENDUE" && (
        <p className="text-amber-300 text-sm bg-amber-950/30 border border-amber-900 rounded-lg px-4 py-3">
          Le front reste SUSPENDU malgré ce résultat. Seul un RESPONSABLE ou un ADMINISTRATEUR peut valider la remise en exploitation.
        </p>
      )}
      {showReactivate && (
        <Button
          data-testid="inspection-result-reactivate-button"
          onClick={() => navigate(`/remise-en-service/${result.Front_ID}`)}
          className="w-full bg-red-600 hover:bg-red-500 text-white font-bold uppercase"
        >
          <Undo2 className="w-4 h-4 mr-2" /> Lancer la remise en exploitation
        </Button>
      )}
      <Button data-testid="inspection-done-back-button" onClick={() => navigate(backTo)} className="bg-cyan-500 hover:bg-cyan-400 text-black font-bold uppercase">
        Retour
      </Button>
    </div>
  );
};
